import { createReducer } from '@reduxjs/toolkit'

import { selectPercent } from './actions'

interface BurnSteerState {
  readonly percent: number
}

const initialState: BurnSteerState = {
  percent: 0,
}

export default createReducer<BurnSteerState>(initialState, (builder) =>
  builder.addCase(selectPercent, (state, { payload: { percent } }) => {
    return {
      ...state,
      percent,
    }
  })
)
